var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { useContent, useCopy } from "../Content/Content";
import { colors } from "../shared/constants";
var StyledInput = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid\n    ", ";\n  font-size: 1rem;\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"], ["\n  width: ", ";\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid\n    ", ";\n  font-size: 1rem;\n  &:focus {\n    outline: none;\n    border-color: ",
    ";\n  }\n"])), function (props) { return props.width || "100%"; }, function (props) { var _a, _b, _c; return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.light) || colors.SKY_BLUE; }, function (props) { var _a, _b, _c; return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.dark) || colors.ULTRAMARINE_BLUE; });
export var Input = function (_a) {
    var contentKey = _a.contentKey, rest = __rest(_a, ["contentKey"]);
    var theme = useContent().theme;
    var placeholder = useCopy(contentKey);
    return React.createElement(StyledInput, __assign({ placeholder: placeholder, theme: theme }, rest));
};
var templateObject_1;
